import { RootState } from '../store/configureStore';

export const isSendingEmail = (state: RootState) =>
  state?.email?.isSendingEmail;

export const didSendingEmailFailed = (state: RootState) =>
  state?.email?.sendingEmailFailed;
